module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "middle-ware-wrapper"
  }, [_c('div', {
    class: _vm.icon
  }), _vm._v(" "), _c('p', {
    staticClass: "middle-tips-font"
  }, [_vm._v(_vm._s(_vm.midFont))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-95f77448!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MidWare.vue
// module id = 607
// module chunks = 1